@if (type === 'success') {
  <div>
    <h2 mat-dialog-title style="margin-left: 2%">New Patron Profile Created</h2>
    <div mat-dialog-content>
      <div class="container-fluid">
        @if (patronDetails) {
          <div class="row">
            <div class="col-12">
              <div>
                <strong>Library Card Number: {{ patronDetails?.libraryCardNumber }}</strong>
              </div>
              <div>
                <strong>Last Name: {{ patronDetails?.lastName }}</strong>
              </div>
              <div>
                <strong>User Name: {{ patronDetails?.userName }}</strong>
              </div>
              <div>
                <strong>Password: {{ patronDetails?.password }}</strong>
              </div>
              <div style="margin-bottom: 2%">
                <strong>Patron Id: {{ patronDetails?.patronId }}</strong>
              </div>
            </div>
          </div>
        }
      </div>
    </div>
    <div mat-dialog-actions align="end">
      <button
        mat-button
        role="button"
        type="button"
        aria-label="OK"
        cdkFocusInitial
        (click)="okayClick()"
      >
        OK
      </button>
    </div>
  </div>
}

@if (type === 'fail') {
  <div>
    <h2 mat-dialog-title style="margin-left: 2%">New Patron Profile Not Created</h2>
    <div mat-dialog-content>
      <div class="container-fluid">
        @if (patronDetails) {
          <div class="row">
            <div class="col-12" [innerHTML]="patronDetails"></div>
          </div>
        }
      </div>
    </div>
    <div mat-dialog-actions align="end">
      <button
        mat-button
        role="button"
        type="button"
        aria-label="OK"
        cdkFocusInitial
        (click)="closeClick()"
      >
        Close
      </button>
    </div>
  </div>
}
